import {
  Avatar,
  Button,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  SwipeableDrawer,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import DialogHeader from '../DialogHeader';
import UpdateTeamMembers from './UpdateTeamMembers';
import BackDropLoading from '../../../common/models/BackDrop';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '40vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: '80vw',
    },
  },
  backdrop: {
    '& .MuiBackdrop-root ': {
      backgroundColor: 'transparent !important',
      opacity: '0 !important',
    },
  },
}));

const ViewAssociatedTeamMembers = (props) => {
  const { warehouseDetails, handleClose } = props;
  const classes = useStyles();
  const [openDialogBox, setDialogBox] = useState({
    open: false,
    parameter: null,
  });

  const handleDialogBox = (value) => {
    setDialogBox({
      open: !openDialogBox.open,
      parameter: value,
    });
  };

  const handleCloseDialogBox = () => {
    setDialogBox({
      open: false,
      parameter: null,
    });
  };



  let backdropLoading = useSelector((state) => state.pcmp.common.files.backdropLoading);

  return (
    <React.Fragment>
      <div className={classes.list}>
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          style={{ padding: '1rem' }}
        >
          <Grid item xs={12}>
            <DialogHeader header={'Associated team members'} />
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                style={{
                  whiteSpace: 'nowrap',
                  fontSize: '1.5rem',
                  fontWeight: '500',
                  paddingBottom: '10px',
                  justifySelf: 'flex-start',
                }}
              >
                {warehouseDetails.warehouseName}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <List>
                {warehouseDetails.associatedTeamMembers.map((user) => (
                  <ListItem key={user.saasUserId} alignItems='center'>
                    <ListItemAvatar style={{ margin: 0 }}>
                      <Avatar>{user.name.charAt(0)}</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant='subtitle1'
                          style={{ fontWeight: 500 }}
                        >
                          {user.name}
                        </Typography>
                      }
                      secondary={<>{`${user.department} - ${user.roleName}`}</>}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '1rem',
            alignContent: 'flex-end',
          }}
        >
          <Button
            variant='contained'
            color='secondary'
            style={{ textTransform: 'none' }}
            onClick={() => handleDialogBox(warehouseDetails)}
          >
            Update team members
          </Button>
        </Grid>
      </div>
      {openDialogBox.open && (
        <SwipeableDrawer
          anchor={'right'}
          open={openDialogBox.open}
          // onClose={() =>
          //   setDialogBox({
          //     open: false,
          //     parameter: null,
          //   })
          // }
          onOpen={() => handleDialogBox(warehouseDetails)}
          className={!backdropLoading && classes.backdrop}
        >
          
      <BackDropLoading />
          <UpdateTeamMembers
            warehouseDetails={openDialogBox.parameter}
            handleClose={() => handleCloseDialogBox()}
            handleCloseAllDialogBox={() => {
              handleCloseDialogBox();
              handleClose();
            }}
          />
        </SwipeableDrawer>
      )}
    </React.Fragment>
  );
};

export default ViewAssociatedTeamMembers;
